template.component.service_map = () => {

	var service_page = '#service-page';

	if ($(service_page).length) {

		/* eslint-disable no-unused-vars */
		/* eslint-disable no-undef */
		var theme_url = '/app/themes/charitypress-rd-look-ahead',
			services_json_url = '/wp-json/json/services',
			regions_json_url = '/wp-json/json/regions',
			default_lat = window.map_initial_lat,
			default_lng = window.map_initial_lng,
			default_zoom = window.map_initial_zoom,
			service_cats = window.service_cats,
			$no_services_form = $('.no-services-form'),
			$no_services_hidden = $no_services_form.find('.gfield_visibility_hidden input'),
			svg_markers = {
				'blue': {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 25,
					fillColor: '#009DCE',
					fillOpacity: 0.5,
					strokeColor: '#0E7EA3',
					strokeOpacity: 0.5,
					strokeWeight: 2
				},
				'green': {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 25,
					fillColor: '#5C9A36',
					fillOpacity: 0.5,
					strokeColor: '#3E6A23',
					strokeOpacity: 0.5,
					strokeWeight: 2
				},
				'orange': {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 25,
					fillColor: '#CE7019',
					fillOpacity: 0.5,
					strokeColor: '#A75A12',
					strokeOpacity: 0.5,
					strokeWeight: 2
				},
				'pink': {
					path: google.maps.SymbolPath.CIRCLE,
					scale: 25,
					fillColor: '#9C0059',
					fillOpacity: 0.5,
					strokeColor: '#730142',
					strokeOpacity: 0.5,
					strokeWeight: 2
				},
			},
			change_colour = 'change-map-colours';

		var vm = new Vue({
			el: service_page,
			data: {
				services: null,
				regions: null,
				current_region: '',
				default_region: null,
				category: service_cats,
				dark_theme: false,
				markers: [],
				learning_total: 0,
				mental_total: 0,
				homelessness_total: 0,
				young_total: 0,
				no_services: false,
				marker: null
			},
			watch: {

				current_region: function(val) {

					window.location.hash = '';
					window.location.hash = change_colour;

					this.current_region = val;

					for(var i = 0; i < this.regions.length; i++) {

						if(this.regions[i].post.slug === val) {

							var zoom = parseInt(this.regions[i].acf.region_zoom);

							if(this.regions[i].number_of_services === 0) {
								this.no_services = true;
								$no_services_form.show();
								window.map.setOptions({
									zoomControl: false,
									mapTypeControl: false,
									maxZoom: zoom
								});
							} else {
								this.no_services = false;
								$no_services_form.hide();
								window.map.setOptions({
									zoomControl: true,
									mapTypeControl: true,
									maxZoom: zoom
								});
							}

							$no_services_hidden.attr('value', this.regions[i].post.name);

							var latlng = new google.maps.LatLng(
								this.regions[i].acf.region_center.lat,
								this.regions[i].acf.region_center.lng
							);

							window.map.setCenter(latlng);
							window.map.setZoom(zoom);
						}
					}

					this.countCategories();
				}
			},
			methods: {

				initMap: function() {

					window.map = new google.maps.Map(document.getElementById('service-map'), {
						center: {
							lat: default_lat,
							lng: default_lng
						},
						zoom: default_zoom,
						maxZoom: default_zoom,
						draggable: false,
						scrollwheel: false,
						panControl: false,
						streetViewControl: false
					});

				},
				getMarkers: function() {

					var self = this;

					$.get(services_json_url)
						.done(function(data) {

							var jsonResponse = data;
							vm.services = jsonResponse;
							self.setMarkers();
							self.countCategories();

						});

					$.get(regions_json_url)
						.done(function(data) {
							var jsonResponse = data;
							vm.regions = jsonResponse;
						})
						.always(function() {
							vm.default_region = vm.regions[0].post.slug;
						});

				},
				setMarkers: function() {

					var self = this;

					for (var i = 0; i < this.services.length; i++) {

						if(this.services[i].acf.service_location.address === '') {
							continue;
						}

						if(this.services[i].acf.service_category === 'mental') {
							this.marker = svg_markers.blue;
						} else if(this.services[i].acf.service_category === 'learning') {
							this.marker = svg_markers.green;
						} else if(this.services[i].acf.service_category === 'homelessness') {
							this.marker = svg_markers.orange;
						} else if(this.services[i].acf.service_category === 'young') {
							this.marker = svg_markers.pink;
						}

						var latlng = new google.maps.LatLng(
							this.services[i].acf.service_location.lat,
							this.services[i].acf.service_location.lng
						);

						var marker = new google.maps.Marker({
							map: map,
							position: latlng,
							category: this.services[i].acf.service_category,
							icon: this.marker,
							clickable: false
							//title: this.services[i].post.post_title
						});

						this.markers.push(marker);

					}
				},
				filterMarkers: function(category) {

					$('.service-page__filter a').removeClass('active');

					if ('all' === category) {
						$('.service-page__filter a[data-category=all]').addClass('active');
					} else {
						$('.service-page__filter a[data-category=' + category + ']').addClass('active');
					}

					for (var i = 0; i < this.services.length; i++) {

						var marker = this.markers[i];

						if (marker.category === category || 'all' === category) {
							marker.setVisible(true);
						} else {
							marker.setVisible(false);
						}
					}
				},
				changeMapColours: function() {

					this.dark_theme = ! this.dark_theme;

					if(this.dark_theme === false) {

						window.map.setOptions({
							styles: [{'featureType':'all','elementType':'labels.text.fill','stylers':[{'saturation':36},{'color':'#000000'},{'lightness':40}]},{'featureType':'all','elementType':'labels.text.stroke','stylers':[{'visibility':'on'},{'color':'#000000'},{'lightness':16}]},{'featureType':'all','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'administrative','elementType':'all','stylers':[{'visibility':'simplified'},{'color':'#3e3e3e'}]},{'featureType':'administrative','elementType':'geometry.fill','stylers':[{'color':'#000000'},{'lightness':20}]},{'featureType':'administrative','elementType':'geometry.stroke','stylers':[{'color':'#000000'},{'lightness':17},{'weight':1.2}]},{'featureType':'landscape','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'landscape','elementType':'geometry','stylers':[{'color':'#c81b1b'},{'lightness':20},{'visibility':'off'}]},{'featureType':'landscape','elementType':'geometry.fill','stylers':[{'visibility':'on'},{'color':'#5c676f'}]},{'featureType':'poi','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'poi','elementType':'geometry','stylers':[{'color':'#000000'},{'lightness':21}]},{'featureType':'road','elementType':'all','stylers':[{'visibility':'simplified'},{'color':'#9d9d9d'}]},{'featureType':'road','elementType':'geometry','stylers':[{'visibility':'simplified'}]},{'featureType':'road','elementType':'geometry.fill','stylers':[{'color':'#55b69f'},{'visibility':'simplified'}]},{'featureType':'road','elementType':'geometry.stroke','stylers':[{'visibility':'simplified'},{'color':'#747474'}]},{'featureType':'road','elementType':'labels.text','stylers':[{'color':'#ffffff'}]},{'featureType':'road','elementType':'labels.text.fill','stylers':[{'visibility':'simplified'},{'color':'#ffffff'}]},{'featureType':'road','elementType':'labels.text.stroke','stylers':[{'visibility':'simplified'},{'color':'#f6f6f6'}]},{'featureType':'road','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'road.highway','elementType':'geometry.fill','stylers':[{'color':'#000000'},{'lightness':17}]},{'featureType':'road.highway','elementType':'geometry.stroke','stylers':[{'color':'#000000'},{'lightness':29},{'weight':0.2}]},{'featureType':'road.arterial','elementType':'geometry','stylers':[{'color':'#000000'},{'lightness':18}]},{'featureType':'road.local','elementType':'geometry','stylers':[{'color':'#000000'},{'lightness':16}]},{'featureType':'transit','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'transit','elementType':'geometry','stylers':[{'color':'#000000'},{'lightness':19}]},{'featureType':'water','elementType':'all','stylers':[{'visibility':'off'}]},{'featureType':'water','elementType':'geometry','stylers':[{'color':'#0f252e'},{'lightness':17}]}]
						});

					} else {

						window.map.setOptions({
							styles: [{'featureType':'all','elementType':'labels.text.fill','stylers':[{'saturation':36},{'color':'#333333'},{'lightness':40}]},{'featureType':'all','elementType':'labels.text.stroke','stylers':[{'visibility':'on'},{'color':'#ffffff'},{'lightness':16}]},{'featureType':'all','elementType':'labels.icon','stylers':[{'visibility':'off'}]},{'featureType':'administrative','elementType':'geometry.fill','stylers':[{'color':'#fefefe'},{'lightness':20}]},{'featureType':'administrative','elementType':'geometry.stroke','stylers':[{'color':'#fefefe'},{'lightness':17},{'weight':1.2}]},{'featureType':'landscape','elementType':'geometry','stylers':[{'color':'#f5f5f5'},{'lightness':20}]},{'featureType':'poi','elementType':'geometry','stylers':[{'color':'#f5f5f5'},{'lightness':21}]},{'featureType':'poi.business','elementType':'labels.text.fill','stylers':[{'saturation':'5'}]},{'featureType':'poi.park','elementType':'geometry','stylers':[{'color':'#dedede'},{'lightness':21}]},{'featureType':'road.highway','elementType':'geometry.fill','stylers':[{'color':'#ffffff'},{'lightness':17}]},{'featureType':'road.highway','elementType':'geometry.stroke','stylers':[{'color':'#ffffff'},{'lightness':29},{'weight':0.2}]},{'featureType':'road.arterial','elementType':'geometry','stylers':[{'color':'#ffffff'},{'lightness':18}]},{'featureType':'road.local','elementType':'geometry','stylers':[{'color':'#ffffff'},{'lightness':16}]},{'featureType':'transit','elementType':'geometry','stylers':[{'color':'#f2f2f2'},{'lightness':19}]},{'featureType':'water','elementType':'geometry','stylers':[{'color':'#e9e9e9'},{'lightness':17}]}]
						});
					}

				},
				countCategories: function() {

					this.learning_total = 0;
					this.mental_total = 0;
					this.homelessness_total = 0;
					this.young_total = 0;

					for (var i = 0; i < this.services.length; i++) {

						if(this.services[i].region[0]) {

							if(this.current_region === '' || this.services[i].region[0]['slug'] === this.current_region) {

								if(this.services[i].acf.service_category === 'learning') {
									this.learning_total++;
								} else if(this.services[i].acf.service_category === 'mental') {
									this.mental_total++;
								} else if(this.services[i].acf.service_category === 'homelessness') {
									this.homelessness_total++;
								} else if(this.services[i].acf.service_category === 'young') {
									this.young_total++;
								}
							}
						}
					}

				}
			},
			mounted: function() {

				this.initMap();
				this.getMarkers();
				this.changeMapColours();

			}
		});

	}
};
